"use strict";
/**
 * GSAP conditional loading
 * Only loads GSAP + ScrollTrigger if elements with [data-gsap] exist on the page
 *
 * @package StandOut
 * @since 2.0.0
 */
document.addEventListener("DOMContentLoaded", () => {
    const gsapElements = document.querySelectorAll("[data-gsap], .button");
    if (gsapElements.length > 0) {
        const needsMorph = document.querySelector("[data-morph]") !== null;
        import("gsap")
            .then(({ gsap }) => {
            const pluginImports = [import("gsap/ScrollTrigger")];
            if (needsMorph) {
                pluginImports.push(import("gsap/MorphSVGPlugin"));
            }
            return Promise.all(pluginImports).then((modules) => {
                const { ScrollTrigger } = modules[0];
                gsap.registerPlugin(ScrollTrigger);
                if (needsMorph && modules[1]) {
                    const { MorphSVGPlugin } = modules[1];
                    gsap.registerPlugin(MorphSVGPlugin);
                }
                globalThis.gsap = gsap;
                globalThis.ScrollTrigger = ScrollTrigger;
                const event = new CustomEvent("gsap-loaded", {
                    bubbles: true,
                });
                window.dispatchEvent(event);
            });
        })
            .catch((error) => {
            console.error("Failed to load GSAP:", error);
        });
    }
});
